module.exports = __webpack_public_path__ + "static/media/folder-dark.fe17debb.svg";